import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Lang } from "../Lang/MainLang";


const Links = styled.div`
    display: flex;
    margin: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    &.linkHome2{
        margin: 0;
    }
    .link{
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        text-decoration: none;
        color: var(--nav-text-1);
        white-space: nowrap;
        cursor: pointer;
        padding: 0 1rem;
        font-weight: 500;
        font-size: 0.75rem;
        border-left: 1px solid var(--nav-border-2);
        :last-child{
            border: none;
        } 
    }
`

export const NavLinks =({classname  })=>{
    return(
        <Links className={classname}>
            <Link to='/shops/'  className='link'> {Lang.Footer.shops}</Link>
            {/* <Link className=' link ' to={"/singup-seller"}>
                {Lang.Footer.shopRequest}    
            </Link> */}
            <Link className=' link ' to={"/brands/"}>
                {Lang.Footer.brands}    
            </Link>
            <Link to='/aboutus/' className='link'> {Lang.Footer.aboutUs}</Link>
            <Link to='/contactus/' className='link'> {Lang.Footer.contactUs}</Link>
            <Link to='/application' className='link'> {Lang.Footer.app}</Link>
            <a href={process.env.REACT_APP_MAIN + '/blog/'} className=' link  '> {Lang.Footer.blog}</a>
        </Links>
    )
}